export default class PersonAchievementDomainService {
    static fromJSON(json) {
        // @ts-expect-error - TS2740 - Type '{ createdDateAsDate: any; }' is missing the following properties from type 'PersonAchievement': id, createdDate, expirationDate, text, and 3 more.
        return Object.assign(Object.assign({}, json), { createdDateAsDate: json.createdDateAsDate && new Date(json.createdDateAsDate) });
    }
}
